import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { buildSearchIndex, SearchItem } from "../search/searchIndex";

const staticSearchItems: SearchItem[] = [
  {
    id: "home",
    title: "Home",
    description: "Landing page",
    path: "/",
    category: "Page",
  },
  {
    id: "about",
    title: "About",
    description: "Introduction and mission",
    path: "/about",
    category: "Page",
  },
  {
    id: "our-story",
    title: "Our Story",
    description: "About UNEPAL",
    path: "/about#our-story",
    category: "Section",
  },
  {
    id: "why-unepal",
    title: "Why UNEPAL",
    description: "Why choose UNEPAL",
    path: "/about#why-unepal",
    category: "Section",
  },
  {
    id: "vision-mission",
    title: "Vision & Mission",
    description: "University vision and mission",
    path: "/about#vision-mission",
    category: "Section",
  },
  {
    id: "advisors",
    title: "Advisors",
    description: "Leadership and advisors",
    path: "/advisors",
    category: "Page",
    content: "World-Class Academic Standards & Advisors",
  },
  {
    id: "undergraduate",
    title: "Undergraduate Programs",
    description: "SAST program overview",
    path: "/sast",
    category: "Page",
  },
  {
    id: "graduate",
    title: "Graduate Programs",
    description: "Master of Public Policy",
    path: "/mpp",
    category: "Page",
  },
  {
    id: "apply",
    title: "Apply",
    description: "Admissions form",
    path: "/application-form",
    category: "Page",
  },
  {
    id: "vacancies",
    title: "Vacancies",
    description: "Open positions",
    path: "/vacancy",
    category: "Page",
  },
  {
    id: "academic-vacancies",
    title: "Academic Vacancies",
    description: "Academic job postings",
    path: "/academic-vacancies",
    category: "Page",
  },
  {
    id: "news",
    title: "News",
    description: "Latest university news",
    path: "/news",
    category: "Page",
  },
  {
    id: "events",
    title: "Events",
    description: "Upcoming events",
    path: "/events",
    category: "Page",
  },
  {
    id: "faqs",
    title: "FAQs",
    description: "Frequently asked questions",
    path: "/faqs",
    category: "Page",
  },
  {
    id: "contact",
    title: "Contact",
    description: "Contact information",
    path: "/contact",
    category: "Page",
  },
  {
    id: "community-faculty",
    title: "Community Faculty",
    description: "Community & faculty",
    path: "/community-faculty",
    category: "Page",
  },
  {
    id: "community-university",
    title: "Community University",
    description: "Campus as community",
    path: "/community-university",
    category: "Page",
  },
  {
    id: "ways-to-give",
    title: "Ways to Give",
    description: "Support UNEPAL",
    path: "/community-university#ways-to-give",
    category: "Section",
  },
  {
    id: "about-unepal",
    title: "About UNEPAL",
    description: "About UNEPAL introduction",
    path: "/about",
    category: "Section",
    content: "About UNEPAL",
  },
  {
    id: "admission-policy-tab",
    title: "Admission Policy",
    description: "Admissions policy and guidelines",
    path: "/application-form#financial-aid",
    category: "Section",
    content: "Admission Policy",
  },
  {
    id: "scholarships-financial-aid-tab",
    title: "Scholarships and Financial Aid",
    description: "Scholarships and financial aid information",
    path: "/application-form#financial-aid",
    category: "Section",
    content: "Scholarships and Financial Aid",
  },
  {
    id: "academic-areas-majors",
    title: "Academic Areas & Majors",
    description: "Academic disciplines and majors offered",
    path: "/sast#td_tab_2",
    category: "Section",
    content: "Academic Areas & Majors",
  },
  {
    id: "academic-calendar",
    title: "Academic Calendar",
    description:
      "MPP Academic Calendar 2083 (2026/2027) with important dates and events",
    path: "/mpp#calendar",
    category: "Academic",
    content:
      "University of Nepal Master of Public Policy Academic Calendar, 2083 (2026/2027) First Semester Baishakh, 2083 || April/May 2026 Orientation program for the new students First semester classes begin Jestha, 2083 || May/June 2026 PDR Seminar Ashad, 2083 || June/July 2026 PDR Seminar Mid-Term Exam Week || Submission/Presentation Second Semester Asoj, 2083 || September/October 2026 Second Semester classes begin Dashain Holiday Kartik, 2083 || October/November 2026 Dashain holiday PDR Seminar Tihar holiday Poush, 2083 || December/January 2027 PDR Seminar Christmas holiday Prithibi Jayanti Magh, 2083 || January/February 2027 Maghi Parba holiday Final exam week",
  },
  {
    id: "calendar-orientation",
    title: "Orientation Program",
    description:
      "New student orientation program - Baishakh 12, 2083 (April 22)",
    path: "/mpp#calendar",
    category: "Calendar Event",
  },
  {
    id: "calendar-classes-begin",
    title: "First Semester Classes Begin",
    description: "Classes start - Baishakh 14, 2083 (April 27)",
    path: "/mpp#calendar",
    category: "Calendar Event",
  },
  {
    id: "calendar-pdr-seminar",
    title: "PDR Seminar",
    description:
      "Professional Development and Research Seminars throughout Jestha and Asadh",
    path: "/mpp#calendar",
    category: "Calendar Event",
  },
  {
    id: "calendar-midterm",
    title: "Mid-term Examination",
    description:
      "First semester mid-term exams - Asadh 10 to 17, 2083 (June 24 to July 1)",
    path: "/mpp#calendar",
    category: "Calendar Event",
  },
  {
    id: "calendar-end-semester",
    title: "End Semester Examination",
    description: "First semester end examinations - Asadh 25 to Saun 8, 2083",
    path: "/mpp#calendar",
    category: "Calendar Event",
  },
  {
    id: "calendar-grade-posting",
    title: "Grade Posting",
    description:
      "Grade posting and result publication - Saun 15, 2083 (July 30)",
    path: "/mpp#calendar",
    category: "Calendar Event",
  },
  {
    id: "calendar-second-semester",
    title: "Second Semester Classes Begin",
    description: "Second semester classes start - Saun 22, 2083 (August 6)",
    path: "/mpp#calendar",
    category: "Calendar Event",
  },
];

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query")?.trim() ?? "";
  const [searchIndex, setSearchIndex] = useState<SearchItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const loadSearchIndex = async () => {
      setLoading(true);
      try {
        const items = await buildSearchIndex();
        if (!active) return;
        setSearchIndex(items);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadSearchIndex();

    return () => {
      active = false;
    };
  }, []);

  const items = useMemo(
    () => [...staticSearchItems, ...searchIndex],
    [searchIndex],
  );

  const normalizedQuery = query.toLowerCase();
  const filteredItems = useMemo(() => {
    if (!normalizedQuery) return items;

    return items.filter((item) => {
      const haystack =
        `${item.title} ${item.description} ${item.category} ${item.content ?? ""}`.toLowerCase();
      return haystack.includes(normalizedQuery);
    });
  }, [items, normalizedQuery]);

  return (
    <div className="td_section td_pt_100 td_pb_100">
      <div className="container">
        <div className="td_height_120 td_height_lg_40" />
        <div className="td_height_120 td_height_lg_40" />
        <div className="td_height_40 td_height_lg_40" />
        {loading ? (
          <div className="td_text_center td_mt_30">Searching...</div>
        ) : (
          <div className="td_mt_30">
            <div className="td_search_summary">
              {normalizedQuery ? (
                <>
                  <strong>{filteredItems.length}</strong> result
                  {filteredItems.length !== 1 ? "s" : ""} found for{" "}
                  <span>"{query}"</span>
                </>
              ) : (
                <>Search the UNEPAL website</>
              )}
            </div>

            {filteredItems.length > 0 ? (
              <div className="td_search_results_grid">
                {filteredItems.map((item) => (
                  <Link key={item.id} to={item.path} className="td_search_card">
                    <h3 className="td_search_title">{item.title}</h3>

                    <p className="td_search_description">{item.description}</p>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="td_search_empty">
                <div className="td_search_empty_icon">🔍</div>

                <h3>No Results Found</h3>

                <p>
                  We couldn't find anything matching <span>"{query}"</span>. Try
                  different keywords.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="td_height_40 td_height_lg_40" />
    </div>
  );
};

export default SearchPage;
